var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3811 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3811,
    height: 1080,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 3811,
    height: 1077,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1431.5,
    cy: 335.5,
    r: 87.5,
    fill: "#FFE872"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1956 391H1879C1880.39 386.929 1882.21 382.18 1887.04 378.357C1893.07 373.578 1898.02 370.291 1905.9 374.008C1913.79 377.725 1919.82 372.946 1930.95 367.636C1939.86 363.389 1951.36 381.442 1956 391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424 391H347C348.392 386.929 350.214 382.18 355.038 378.357C361.069 373.578 366.018 370.291 373.904 374.008C381.789 377.725 387.819 372.946 398.952 367.636C407.858 363.389 419.361 381.442 424 391Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2112.97 466.533H1996C1996 459.695 1998.74 444.653 2009.5 446.021C2020.26 447.388 2030.4 433.23 2036 427.532C2041.6 421.55 2059.59 418.843 2071.96 436.62C2074.43 439.753 2081.64 446.021 2090.78 446.021C2109.6 447.388 2113.41 460.265 2112.97 466.533Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M580.966 466.533H464C464 459.695 466.745 444.653 477.5 446.021C488.255 447.388 498.398 433.23 504 427.532C509.602 421.55 527.592 418.843 539.961 436.62C542.426 439.753 549.641 446.021 558.783 446.021C577.605 447.388 581.414 460.265 580.966 466.533Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3544.97 488.533H3428C3428 481.695 3430.74 466.653 3441.5 468.021C3452.26 469.388 3462.4 455.23 3468 449.532C3473.6 443.55 3491.59 440.843 3503.96 458.62C3506.43 461.753 3513.64 468.021 3522.78 468.021C3541.6 469.388 3545.41 482.265 3544.97 488.533Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2721.97 378.533H2605C2605 371.695 2607.74 356.653 2618.5 358.021C2629.26 359.388 2639.4 345.23 2645 339.532C2650.6 333.55 2668.59 330.843 2680.96 348.62C2683.43 351.753 2690.64 358.021 2699.78 358.021C2718.6 359.388 2722.41 372.265 2721.97 378.533Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.97 410.533H1432C1432 403.695 1439.74 388.653 1450.5 390.021C1461.26 391.388 1466.4 377.23 1472 371.532C1477.6 365.55 1495.59 362.843 1507.96 380.62C1510.43 383.753 1517.64 390.021 1526.78 390.021C1545.6 391.388 1549.41 404.265 1548.97 410.533Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1296,
    y: 201,
    width: 273,
    height: 273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 14,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1905.5,
    y1: 3,
    x2: 1905.5,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F9F4",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2FFF6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.f6f159d9.svg";
export { ForwardRef as ReactComponent };